import { FormTheme } from '../../types';

export const DEFAULT_THEME: FormTheme = {
  heading1: '#000000',
  paragraph: '#000000',
  link: '#1677ff',
  label: '#000000',
  actionButtonText: '#ffffff',
  actionButtonBackground: '#1677ff',
  actionButtonBorder: '#1677ff',
  basicButtonText: '#6366f1',
  basicButtonBackground: '#ffffff',
  basicButtonBorder: '#6366f1',
  formInputText: '#808080',
  formInputPlaceholder: '#D7D9E3',
  formInputBackground: '#ffffff',
  formInputBorder: '#d1d5db',
  formInputHeight: 42,
  formInputFontSize: 14,
  formTextareaHeight: 96,
  borderRadius: 8,
  buttonFontSize: 16,
  buttonPaddingY: 8,
  buttonPaddingX: 20,
  chipFontSize: 14,
  chipFontWeight: 'regular',
  chipBackground: '#ffffff',
  chipText: '#374151',
  chipBorder: '#e5e7eb',
  chipHoverBackground: '#ffffff',
  chipHoverBorder: '#c4b5fd',
  chipSelectedBackground: '#ffffff',
  chipSelectedText: '#7c3aed',
  chipSelectedBorder: '#8b5cf6',
  chipPaddingY: 6,
  chipPaddingX: 10,
  chipRadius: 8,
  formPaddingY: 32,
  formPaddingX: 32,
  formWidth: 'medium',
  formMaxWidth: 720,
  background: '#ffffff',
  fontFamily: 'Arial, sans-serif',
  fontWeight: '700',
  paragraphFontFamily: 'Arial, sans-serif',
  paragraphFontWeight: 'regular',
  buttonFontFamily: 'Arial, sans-serif',
  buttonFontWeight: '700',
  successTitle: 'Form Submitted Successfully!',
  successMessage: 'Thank you for your time. Your response has been recorded.',
  successButtonLabel: 'Okay',
  stepperVariant: 'numbered',
  stepperPosition: 'top',
  stepperActiveColor: '#4f46e5',
  stepperInactiveColor: '#c7c7d1',
  stepperLabelColor: '#6b7280',
  stepperHideLabels: false,
};

export default DEFAULT_THEME;
